import { useEffect, useState, useRef } from "react";

const ScriptLoader = ({
	src,
	content,
	id,
	async = false,
	defer = false,
	onLoad,
	onError,
	attributes = {},
}) => {
	const [status, setStatus] = useState("idle");
	const scriptRef = useRef(null);

	useEffect(() => {
		if (!src && !content) return;

		if (status === "ready") return;

		const script = document.createElement("script");
		scriptRef.current = script;

		// Ustawienie atrybutów
		if (id) script.id = id;
		if (src) script.src = src;
		if (async) script.async = true;
		if (defer) script.defer = true;

		// Dodanie niestandardowych atrybutów
		Object.entries(attributes).forEach(([key, value]) => {
			script.setAttribute(key, value);
		});

		// Obsługa zdarzeń
		const handleLoad = () => {
			setStatus("ready");
			if (onLoad) onLoad();
		};

		const handleError = (error) => {
			setStatus("error");
			if (onError) onError(error);
		};

		script.addEventListener("load", handleLoad);
		script.addEventListener("error", handleError);

		// Dodanie treści inline jeśli istnieje
		if (content) {
			script.textContent = content;
		}

		// Dodanie skryptu do dokumentu
		document.body.appendChild(script);

		return () => {
			// Bezpieczne usuwanie event listenerów
			if (script) {
				script.removeEventListener("load", handleLoad);
				script.removeEventListener("error", handleError);
			}

			// Bezpieczne usuwanie skryptu z DOM
			try {
				if (script && script.parentNode) {
					script.parentNode.removeChild(script);
				}
			} catch (error) {
				// Ignorujemy błędy usuwania - element może już nie istnieć
				// Co jest normalnym stanem w niektórych przypadkach
				if (process.env.NODE_ENV === "development") {
					// eslint-disable-next-line no-console
					console.warn(
						"ScriptLoader: Nie można usunąć skryptu z DOM:",
						error
					);
				}
			}
		};
	}, [src, content, id, async, defer, onLoad, onError, status]);

	return null;
};

export default ScriptLoader;
